<template>
  <div class="chatMessage">
    <!--入口图-->
    <div class="entrance" v-if="!openDetail" @click="openDetail=true">
      <span v-if="unreadMessageNum>0">{{unreadMessageNum}}</span>
      <img src="./img/entrance.png" alt="">
    </div>
    <!--右下角联系人-->
    <div class="detail" v-if="openDetail">
      <div class="top">
        <div class="left">
          <em> <img src="/static/img/chartnotice.png" alt=""> </em>
          <span v-if="unreadMessageNum">{{unreadMessageNum}}</span>
        </div>
        <div class="center">
          <em> <img src="/static/img/chartserch.png" alt=""> </em>
          <input type="text" v-model="searchText"  placeholder="搜索">
        </div>
        <div class="right"><em class="icon" @click="openDetail = false">&#xe63b;</em></div>
      </div>
      <div class="content" v-if="searchText===''">
        <div v-for="(v,i) in contactData" :key="i" v-if="!v.ishide" class="box">
          <!--外层标题-->
          <div class="label" @click="v.expand=!v.expand">
            <div class="left">
              <em class="icon_v3" :class="{'expand':v.expand}">&#xe670;</em>
              <h4>{{v.label}}</h4>
            </div>
            <div class="right">{{`(${v.onlineNum}/${v.list.length})`}}</div>
          </div>
          <div class="list" v-if="v.expand">
            <!--内层数据-->
            <div v-for="(m,n) in v.list" :key="n" class="item"
                 @dblclick="dialogCurrent.inviteCode!=m.inviteCode&&openDialog(m, i)">
              <div class="left">
                <img :src="chooseHeanderImg(m)" alt="">
                <div>
                  <span class="name" v-if="i == 0">我的上级</span>
                  <span class="name" v-else>{{m.cn}}</span>
                  <span class="lastText" v-html="lastMessage(m)"></span>
                </div>
              </div>
              <div class="right">
                <span class="time" v-if="m.lastMessage">{{filter_time(m.lastMessage.createTime)}}</span>
                <span class="unread" v-if="m.unReadCount>0">{{m.unReadCount}}</span>
              </div>

            </div>
          </div>
        </div>
      </div>
      <!--搜索-->
      <div class="content" v-if="searchText!==''">
      <div class="box">
        <div class="list">
          <!--内层数据-->
          <div v-for="(m,n) in searchList" :key="n" class="item"
               @dblclick="dialogCurrent.inviteCode!=m.inviteCode&&openDialog(m)">
            <div class="left">
              <img :src="chooseHeanderImg(m)" alt="">
              <div>
                <span class="name">{{m.cn}}</span>
                <span class="lastText" v-html="lastMessage(m)"></span>
              </div>
            </div>
            <div class="right">
              <span class="time" v-if="m.lastMessage">{{filter_time(m.lastMessage.createTime)}}</span>
              <span class="unread" v-if="m.unReadCount>0">{{m.unReadCount}}</span>
            </div>

          </div>
        </div>
      </div>

    </div>

    </div>
    <!--新消息提示-->
    <div class="newMessagePrompt" >
      <div v-for="(v,i) in newMessage" :key="i" @click="openDialog(v),newMessageRead(i)" class="item" :class="v.unReadCount?'show':'hide'">
        <img :src="chooseHeanderImg(v)" alt="" v-if="v">
        <span>收到新消息</span>
      </div>

    </div>
    <!--对话框-->
    <div class="dialogBox" v-show="dialogBoxShow" :class="{'hasChatRecord':chatRecordShow}">
      <div class="dialogBoxList">
        <div v-for="(v,i) in dialogBoxList" :key="i" @click.stop="changeDislog(v)" class="item"
             :class="{'active':v.inviteCode == dialogCurrent.inviteCode}">
          <div class="left">
            <img :src="chooseHeanderImg(v)" alt="">
          </div>
          <div class="right">
            <div class="name" v-if="!istopProxy">{{v.cn}}</div>
            <div class="name" v-else>我的上级</div>
            <div class="lastMessage">{{lastMessage(v)}}</div>
          </div>
          <div class="itemClose">
            <em class="icon_v3" @click.stop="deleteDialogItem(v,i)">&#xe647;</em>
          </div>
        </div>
      </div>
      <div class="dialogBoxContent" >
        <!--这里火狐浏览器不支持拖拽api-->
        <div class="top" @mousedown="canDrag=true" @mousemove.stop.prevent="dragMove($event)"  @mouseup="dragEnd($event)" @mouseleave="dragEnd($event)">
        <!--<div class="top" >-->
          <div class="left">
            <img :src="chooseHeanderImg(dialogCurrent)" alt="">
            <div>
              <span class="name"v-if="!istopProxy">{{dialogCurrent.cn}}</span>
              <span class="name"v-else>我的上级</span>
              <span class="offline"
                    :class="dialogCurrent.isOnline?'online':''">{{dialogCurrent.isOnline?'在线':'离线'}}</span>
            </div>
          </div>
          <div class="right">
            <!--<em class="icon_v3">&#xe72d;</em>-->
            <em class="icon" @click="closeAllMessage()">&#xe63b;</em>
          </div>
        </div>

        <div class="messageList" id="messageList">
          <div v-for="(v,i) in messageList" :key="i" class="item">
            <div class="date" v-if="i==0 || messageDateShow(i,dialogCurrent.messageList)">
              {{messageDate(v.createTime)}}
            </div>
            <div :class="v.isSelf?'messageSend':'messageReceive'">
              <div class="photo"><img :src="v.isSelf?headerImg['self']:chooseHeanderImg(dialogCurrent)" alt=""></div>
              <div class="content">
                <span class="tri"></span>
                <div class="text" v-html="v.text?v.text.replace(/\n/g,'<br/>'):''"></div>
              </div>
            </div>
          </div>
        </div>

        <div class="bottom">
          <div class="tool">
            <div class="left"></div>
            <div class="right" @click="openRecord()"><em> <img src="/static/img/chartList.png" alt=""> </em>聊天记录</div>
          </div>
          <!--这里的v-model不能加修饰符trim，不然当ctrl+enter的时候，添加\n来换行时不起效果，因为被修饰符trim删除了  :class="{'close':close}" :disabled="close"-->
          <textarea class="text" autofocus placeholder="请输入聊天内容"  :readonly="sending"
                    v-model="writeData" @keydown.ctrl="ctrlIsDown=true" @keyup.17="ctrlKeyup()"
                    @keyup.ctrl.enter="newline()" @keypress.enter="!sendMessage(writeData)"></textarea>
          <div class="reLink" v-show="!websocketStatus" >重新链接中...</div>
          <div class="btn">
            <span class="end" @click="closeMessage()">关闭</span>
            <span class="send" @click="sendMessage()">发送</span>
          </div>
        </div>
      </div>

      <div class="chatRecord" v-if="chatRecordShow">
        <div class="top">
          <span>聊天记录</span>
          <em class="icon" @click="closeChatRecord()">&#xe63b;</em>
        </div>
        <div class="chatRecordContent" id="chatRecordContent">
          <div v-for="(v,i) in chatRecordList" :key="i" class="item" :class="'item'+v.id">
            <div class="date" v-if="i==0 || messageDateShow(i,chatRecordList)">{{messageDate(v.createTime)}}</div>
            <div :class="v.isSelf?'messageSend':'messageReceive'">
              <div class="photo"><img :src="v.isSelf?headerImg['self']:chooseHeanderImg(dialogCurrent)" alt=""></div>
              <div class="content">
                <span class="tri"></span>
                <div class="text" v-html="v.text?v.text.replace(/\n/g,'<br/>'):''"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
	import {mapState, mapMutations, mapActions} from 'vuex';
	import service from "./../../js/service.js";


	export default {
		data() {
			return {
				openDetail: false, // 是否打开上下级详情列表
        searchText: '', // 搜索输入框
				// 上下级数据
				contactData: [ // expand  是否展开我的上下级列表  这里只能有两个对象  千万别加第三个对象了
					{label: '我的上级', expand: false,ishide:false, onlineNum: 0, list: []},
					{label: '我的下级', expand: false,ishide:false, onlineNum: 0, list: []},
				],
        isshowTopLv:false,
        newMessage: [], // 新消息提示
        // 对话框数据 所有的对话框数据
        dialogBoxShow: false, // 控制对话框的显示与否
        dialogBoxList: [],
        istopProxy: false,
				dialogCurrent: {}, // 当前正在聊天的对话框的数据
        canDrag: false, // 是否允许拖拽
				positionX:0, // 保存拖拽时鼠标到对话框左上角的相对距离
				positionY:0,
        writeData: '', // 输入框中的数据
        sending: false, // 正在发送中
        messageList: [], // 消息列表的数据
        headerImg: {
				  self: require('./img/messageList_self.png'),
				  upOnline: require('./img/messageList_up_online.png'),
				  up: require('./img/messageList_up.png'),
				  downOnline: require('./img/messageList_down_online.png'),
				  down: require('./img/messageList_down.png'),
        },
        ctrlIsDown: false, // ctrl是否被按下，这个用来区别ctrl+enter和enter的键盘事件
        initScoll: false, // 对话列表初始化，一开始滚动条是在最上面的，让其到最下面去，发送消息的时候也到最下面去
        chatRecordShow: false, // 聊天记录列表是否展示
        chatRecordIndex: 0, // 获取聊天记录的页数 当前是第几页
        chatRecordList: [], // 聊天记录的数据
        isFindChatRecord: true, // 是否可以继续翻译
      }
		},
		computed: {
			...mapState(['unreadMessageNum', 'websocket', 'websocketStatus','baseInfo']),
      // 联系人搜索人民  前端搜索
      searchList(){
			  if (this.searchText === '') return
			  let arr = []
			  for(let val of this.contactData){
			  	arr = arr.concat(val.list.filter((e)=>(e.cn.includes(this.searchText))))
			  }
			  return arr
      },
		},
		watch: {
      websocket(){
        this.initReceive() // 初始化接收消息--socket
      },
      dialogCurrent: {
        deep: true,
        handler: function (val) {
          this.messageList = val.messageList
        }
      },
      websocketStatus(cur,bef){
        if(bef) return // 如果之前是连接的  就不执行下面的
        this.sending = false // 初始化发送中
      },
      writeData(val){
        val.length>300 && (this.writeData = val.substr(0,300))
      },
      baseInfo(a,b){
        if(a && a.mainAccount.userLevel === 1){
          // this.contactData = true;
          this.contactData[0]['ishide'] = true;
        }
        // console.log(a,b)
      }
    },
		methods: {

      ...mapMutations(['setData']),
			// 转换时间
			filter_time(t) {
				return moment(t).format('HH:mm')
			},
      // 选择投降
      chooseHeanderImg(v){
        return v.isParent ? this.headerImg['up'+(v.isOnline?'Online':'')]:this.headerImg['down'+(v.isOnline?'Online':'')]
      },
			// 初始化上下级列表的额数据
			initList() {
				// 获取上下级列表的数据
				service.postDefault(this, '/message-push/queryRelativeUserList', {}).then(function (result) {
          let res = result.data
          let up = [] // 存放上级
          let down = [] // 存放下级
          let unReadCount = 0 // 未读消息
          let inviteCodesList = [] // 这个用于保存所有的邀请码  用于获取最后一条消息
          if(res.code == 0){
            res.data.sort((a,b)=>(b.isOnline - a.isOnline))// 排序 在线的在上面
            res.data.sort((a,b)=>(b.unReadCount - a.unReadCount))// 排序 有未读消息的在最上面

            for(let val of res.data){
            	val.isParent ? down.push(val) : up.push(val) // 区分上级和下级 放在两个数组里面
	            unReadCount += val.unReadCount // 统计所有的未读消息
            }

            // 数据映射
            for (let [i, v] of this.contactData.entries()) {
            	for(let val of i?up:down){
            	  let current = v.list.find((e)=>(e.inviteCode == val.inviteCode))
            		if(current){ // 如果有数据  就刷新现在的状态
                  current.isOnline = val.isOnline
                  current.unReadCount = val.unReadCount
                }else{
            		  val.lastMessage = null
            		  v.list.push(val)
                  inviteCodesList.push(val.inviteCode) // 邀请码组合 这个用于查询最后一条对话消息
                }
            	}
            }
	          this.contactData[0].onlineNum = down.filter(e=>(e.isOnline)).length // 统计在线人数
	          this.contactData[1].onlineNum = up.filter(e=>(e.isOnline)).length // 统计在线人数
	          this.setData({key: "unreadMessageNum", value: unReadCount}) // 写入vuex的未读消息
            inviteCodesList.length && this.findLastMessage(inviteCodesList.join(','), res.data) // 获取每个对话中的最后一条对话消息
          }else{
            console.log(res.message)
          }
				}, function (err) {
					console.log(err)
				})
			},
      // 获取每个对话中的最后一条对话消息
      findLastMessage(inviteCodes, data){
        service.postDefault(this, '/message-push/getLastChatMessageList', {inviteCodes:inviteCodes}).then((result) => {
          let res = result.data
          if (res.code === 0) {
            for(let val of res.data){
            	let obj = data.find((e)=>(e.inviteCode == val.inviteCode)) // 这里要精确查找一下
              if(obj){
                obj.lastMessage = val.lastMessage
              }
            }
          } else {
            this.$Modal.al_default({status: 'warning', content: res.message})
          }
        })
      },
      // 读取对话列表中的最后一条消息 这里的规则是消息列表里面有数据就优先读消息列表的数据
      lastMessage(m){
        return m.messageList&&m.messageList.length ? m.messageList[m.messageList.length-1].text : m.lastMessage ? m.lastMessage.text : ''
      },
			// 打开对话框
			openDialog(v, idx) {
        console.log(idx)
        this.istopProxy = false;
        if(idx === 0)this.istopProxy = true;
        !v.messageList && (v.messageList = []) // 如果不存在messageList就添加这个属性  存放聊天的消息数据
        // 当左边列表中不存在聊天内容时  才添加  不然就是切换已有的聊天框
        !this.dialogBoxList.find((e)=>(e.inviteCode === v.inviteCode)) && (this.dialogBoxList.push(v))
      	this.dialogCurrent = v // 重置或切换聊天框的内容
        this.dialogBoxShow = true // 打开聊天框
        this.initMessageData() // 初始化聊天数据 有未读的就去读取未读的消息
        this.closeChatRecord() // 关闭聊天记录
        this.newMessageRead(this.newMessage.findIndex((e)=>(e.inviteCode == v.inviteCode)))// 新消息提示为已读

			},
      // 点击对话框左侧列表  切换对话框内容
      changeDislog(v){
        this.dialogCurrent = v // 重置或切换聊天框的内容
        // this.initMessageData() // 初始化聊天数据 有未读的就去读取未读的消息
        /*
          切换时不需要重新从后台获取未读的消息  因为持久链接会一直将未读消息传回来 然后保存在本地obj的 messageList 里面
          只需要设置成已读消息即可
        */
        this.writeData = ''// 首先下面的输入框数据要清空！
        // 两个前置条件   消息列表有数据  且最后一条消息不是自己发的
        v.messageList.length>0 && !v.messageList[v.messageList.length - 1].self && this.setReaded(v.messageList[v.messageList.length - 1].id) // 最后这里要把未读的数量清空 前后台都要做
        this.closeChatRecord() // 关闭聊天记录
      },

      initMessageData(){
        this.writeData = ''// 首先下面的输入框数据要清空！
        // 如果有未读消息 就先获取一下未读的消息
        if(this.dialogCurrent.unReadCount > 0){ // 有未读消息就先读取未读消息
          // 这里接口最多只能读取20条数据  所有这里想要一次性获取所有的未读消息只能分次请求
          let p = []
          let  page = Math.ceil(this.dialogCurrent.unReadCount/20)
            for(let i of Array.from({length: page}).map((v,i)=>(i))){
            p.push(service.postDefault(this, '/message-push/getChatMessageList', {
              startIndex: i*20,
              pageSize: (i+1) == page ? this.dialogCurrent.unReadCount%20 : 20,
              inviteCode: this.dialogCurrent.inviteCode
            }))
          }
          Promise.all(p).then((result)=>{
            let arr = []
            for(let val of result){
              let res = val.data
              if(res.code === 0){
                arr = arr.concat(res.data)
              }else{
                console.log(res.message)
              }
            }
            // this.dialogCurrent.messageList = [].concat(arr.reverse()) // 这里需要做个倒叙  因为时间最近的显示在最下面
            for(let val of arr.reverse()){ // 直接写相等的话  不能触发监听器  不知道为啥！
              this.dialogCurrent.messageList.push(val)
            }
            this.setReaded(arr[arr.length - 1].id) // 最后这里要把未读的数量清空 前后台都要做
          }).catch((err)=>{console.log(err)})
        }
      },
      // 读取未读消息之后，把未读的数量清空 前后台都要做
      setReaded(id,bol){ // bol=true代表即时聊天 就是变接受到数据 立马就读取了  这个时候不需要去改未读消息的数量
        service.postDefault(this, '/message-push/setChatMessageRead', {endMsgId: id, inviteCode: this.dialogCurrent.inviteCode}).then((result)=>{
          let res = result.data
          if(res.code === 0){
            if(bol) return
            this.dialogCurrent.unReadCount = this.dialogCurrent.unReadCount - res.data // 前端设置未读消息数量要减去已读消息数量  后端就是接口
            // 还要初始化一下列表中所有的未读消息数量
            this.setData({key: "unreadMessageNum", value: this.unreadMessageNum - res.data})
          }else{
            this.$Modal.al_default({status: 'warning', content: res.message})
          }
        })
      },

      // 点击对话框左侧的叉叉  删除一个对话框数据
      deleteDialogItem(v,i) {
        // 删除这个元素的聊天消息
        delete v['messageList']
        // 先删除item
        this.dialogBoxList.splice(i, 1)
        this.closeChatRecord() // 关闭聊天记录
        // 如果对话列表中没有了  就关闭对话框
        if (this.dialogBoxList.length === 0) {
          this.closeAllMessage()
        } else {
          // 如果删除的是当前聊天框的数据  就切换到第一个聊天内容中去
          v.inviteCode === this.dialogCurrent.inviteCode && this.changeDislog(this.dialogBoxList[0])
        }
      },
      // 点击结束按钮  结束当前聊天框
      closeMessage(){
        let i = this.dialogBoxList.findIndex((e)=>(e.inviteCode == this.dialogCurrent.inviteCode))
        delete this.dialogBoxList[i]['messageList']
        this.dialogBoxList.splice(i,1)
        // 如果对话列表中没有了  就关闭对话框
        if(this.dialogBoxList.length === 0) {
          this.closeAllMessage()
        }else{
          this.changeDislog(this.dialogBoxList[0])
        }
      },
      // 关闭所有的对话框 之后的事件
      closeAllMessage(){
        this.dialogBoxShow = false // 对话框隐藏
        // 由于都是浅复制  所以这里删除消息列表
        for(let val of this.dialogBoxList){ // 如果这个存在的话  存在说明点击的是右上角的叉叉
          delete val['messageList']
        }
        this.dialogBoxList = [] // 数据清空
        this.dialogCurrent = {} // 数据清空
      },
      // 发送消息
      sendMessage(){
        if(this.sending&&this.websocketStatus) return // 如果是在发送中  就不让发送   防止多次发送
        let text = this.writeData.trim().replace(/</g,'&lt;').replace(/>/g,'&gt;')
        //不提交：当输入字符为空的时候，当ctrl被按下（true）的时候
        if (!text || this.ctrlIsDown) {
          return
        }
        this.sending = true // 设置成发送中
        let obj = {
          sendUid: '' + moment().valueOf(), // 这个必须写成唯一的字符串  用户回执
          inviteCode: this.dialogCurrent.inviteCode,
          toParent: this.dialogCurrent.isParent,
          msgType:0,
          message: text
        };
        console.log(this.websocket)
        this.websocket.emit('message', obj, (sendUid)=>{
          console.log("发送数据成功")
          this.sending = false // 设置成  不是发送中
          this.initScoll = false // 初始化对话框消息数据滚动条 --可以自动滑到最下面
          // 发送成功会进来这里 发送成功后将发送的数据展示出来  然后清空输入框
          let obj = {
            createTime: moment().valueOf(),
            text: text,
            isSelf: true,
          }
          this.dialogCurrent.messageList.push(obj)
          this.dialogCurrent.lastMessage = obj
          this.writeData = '' // 将输入框的数据清空
          this.operateScoll(true) // 操作对话框的滚动条到最下面
        })
      },
      // 打开聊天记录
      openRecord(){
        if(this.chatRecordShow) return this.closeChatRecord() // 防止重复点击
        this.chatRecordShow = true
        this.chatRecordIndex = 0 // 初始化页数为0 从第一页开始查询
        this.chatRecordList = []
        this.isFindChatRecord = true // 设置成可以查询的状态
        this.findChatRecord(this.chatRecordIndex) // 获取聊天记录
      },
      // 获取聊天记录
      findChatRecord(i){
        if(!this.isFindChatRecord) return // 如果不能再继续查询了就结束
        service.postDefault(this, '/message-push/getChatMessageList', {
          startIndex: i*20,
          pageSize: (i+1)*20,
          inviteCode: this.dialogCurrent.inviteCode
        }).then((result) => {
          let res = result.data
          if (res.code === 0) {
            if(res.data.length){ // 判断是不是到最后一页了
              this.chatRecordList = res.data.reverse().concat(this.chatRecordList)
              if(i == 0){ // 如果 i = 0 就让滚动条在最下面  不然就在当前位置
                let ul = document.getElementById('chatRecordContent')
                if (!ul) return
                if (!this.init || ul.clientHeight === (ul.scrollHeight - ul.scrollTop)) {
                  //在dom更新之后去操作滚动条，不然是拿不到dom更新修改后的滚动条长度
                  this.$nextTick(function () {
                    ul.scrollTop = ul.scrollHeight
                  })
                }
                // 监听滚动条事件
                ul.onscroll = function () {
                  if(ul.scrollTop == 0){
                    this.findChatRecord(++this.chatRecordIndex)
                  }
                }.bind(this)
              }else{ // 滚动条移动到之前的位置去
                this.$nextTick(()=>{
                  let item = $('#chatRecordContent .item' + (res.data[res.data.length-1].id+1))
                  let ul = $('#chatRecordContent')
                  ul[0].scrollTop = item.offset().top - ul.offset().top // 获取之前第一个元素到父元素顶部的位置 也就是滚动条应该移动的距离
                })
              }
            }else{
              this.isFindChatRecord = false // 不可再查询了
            }
          } else {
            this.$Modal.al_default({status: 'warning', content: res.message})
          }
        })
      },
      // 关闭聊天记录
      closeChatRecord(){
        this.chatRecordShow = false
      },

      // 聊天框内容展示区  是否显示时间栏
      messageDateShow(i,v){
        // 规则：上下两条消息时间间隔大于10分钟就显示
        if((moment(v[i].createTime).valueOf() - moment(v[i-1].createTime).valueOf() )>10*60*1000){
          return true
        }
      },
      messageDate(time){
        return moment(time).format('HH:mm YYYY-MM-DD')
      },

      // 操作滚动条
      operateScoll(bol){  // bol为 true 是在底部  false是在头部
        let ul = document.getElementById('messageList')
        if (!ul) return
        //设置在底部
        if(bol){
          if (!this.initScoll || ul.clientHeight === (ul.scrollHeight - ul.scrollTop)) {
            // 滚动条初始化结束
            this.initScoll = true
            //在dom更新之后去操作滚动条，不然是拿不到dom更新修改后的滚动条长度
            this.$nextTick(function () {
              ul.scrollTop = ul.scrollHeight
            })
          }
        }else{
          //设置在头部
          if (!this.initScoll || ul.clientHeight === 0) {
            // 滚动条初始化结束
            this.initScoll = true
            //在dom更新之后去操作滚动条，不然是拿不到dom更新修改后的滚动条长度
            this.$nextTick(function () {
              ul && (ul.scrollTop = 0)
            })
          }
        }


      },
      // 开始移入拖动时  层级提高到最上面
			// dragStart(v){
      // },
      // 拖拽的时候
			dragMove(e){
        if(!this.canDrag) return
				let ele = $(e.target).parent().parent();
				// 算出鼠标相对元素的位置 保存初始位置即可
        if(!this.positionX){
	        this.positionX = e.clientX - ele[0].offsetLeft; // 当前的距离 减去父元素的距离
	        this.positionY = e.clientY - ele[0].offsetTop;
        }
        if(e.clientX!=0){ // 这里是鼠标释放后e.clientX和e.clientY会等于0 就出问题了
	        ele.css({left:e.clientX-this.positionX,top:e.clientY-this.positionY})
        }
      },
      // 拖拽结束
      dragEnd(e){
        this.canDrag = false
	      this.positionX = 0 // 清楚相对距离  不然下次拖动会出错
      },
      //输入框的换行事件
      newline() {
        this.writeData += '\n';
        return false
      },
      /*
      *  这里的ctrl按起来事件需要做一下处理，不能立即把ctrl按起的状态恢复，
      *  恢复太快的话，会导致在按enter之前就恢复了，这样会直接出发enter事件，所以给个100ms的延迟
      *  话说这个在底层应该是监听的event.keycode的值是否发生了改变来修改这个状态，
      *  当ctrl按下的时再按enter，会先执行ctrl按起的事件再执行enter按下的事件
      *  也就是一个瞬间的动作，虽然我们ctrl一直是按下的状态，但是由于keycode切换的值，
      *  就会在一瞬间里面被认为是抬起了，然后又按下了
       */
      ctrlKeyup() {
        setTimeout(() => {this.ctrlIsDown = false}, 100)
      },



      // 接收消息--socket
      initReceive(){
        this.websocket && this.websocket.on('message', (data)=>{
          console.log("接收到数据")
          data.isSelf = false // 标记 不是发送的消息 就是接受的消息
          // 判断数据是不是当前聊天列表里面的
          // let obj = this.dialogBoxList.find((e)=>(e.inviteCode === data.sendInviteCode))
          let obj = null
          let index = 0
          for(let [i,val] of this.contactData.entries()){
          	obj = val.list.find((e)=>(e.inviteCode === data.sendInviteCode))
            index = i
            if(obj) break
          }
          if(obj){
            // 新消息提示 同一个人的消息提示只能有一条 且不在已打开的对话框里面
            !this.newMessage.find((e)=>(e.inviteCode == obj.inviteCode)) && !this.dialogBoxList.find((e)=>(e.inviteCode === obj.inviteCode)) && (this.newMessage.push(obj))
            obj.lastMessage = data // 设置最后一条消息
            obj.messageList && obj.messageList.push(data) // 如果是当前聊天列表内容的数据  就将数据丢进去
            if(obj.inviteCode === this.dialogCurrent.inviteCode){
              this.setReaded(data.id,true) // 如果就是当前的对话框正在聊天的对象  就直接触发已读机制
              this.operateScoll(true) // 操作对话框的滚动条到最下面
            } else {
              obj.unReadCount++ // 未读消息+1
              this.contactData[index].list.sort((a,b)=>(b.unReadCount-a.unReadCount)) // 排序 有未读消息在最上面
              this.setData({key: "unreadMessageNum", value: this.unreadMessageNum + 1})
            }
          }
        });
      },
      // 新消息已读
      newMessageRead(i) {
        $('.chatMessage .newMessagePrompt .item').eq(i).removeClass('show').addClass('hide')
        setTimeout(() => {this.newMessage.splice(i, 1)}, 500)
      },

			init() {
				this.initList() // 获取上下级联系人的数据
        setInterval(()=>{this.initList()},1000*30) // 循环刷新上下联系人
        this.initReceive() // 接收消息
			}
		},
		created() {
			this.init();
		},
		mounted() {
		},
	}
</script>

<style lang='less' scoped>
  //函数
  .bor(@col) {
    border: 1px solid @col;
  }
  //统一滚动条样式
  .al_scorll(){
    &::-webkit-scrollbar {
      width: 6px;
      height: 4px;
    }
    &::-webkit-scrollbar-thumb {
      border-radius: 15px;
      -webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, .2);
      background: @themeColor;
    }
    &::-webkit-scrollbar-track {
      -webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, .2);
      border-radius: 0;
      background: #edeff1;
    }
  }
  //统一导航条样式  小木条
  .al_navWood{
    &:before{
      content: '';
      position: absolute;
      top: 0;
      left: 0px;
      width: 100%;
      height: 3px;
      background: @themeColor;
      z-index: 10;
    }
  }


  // 变量
  //@bodyColor: #f5f5f5;//投注容器背景颜色颜色
  @themeColor: #2396F7; // 主题颜色--一些按钮背景色  字体颜色
  @themeColor_Sec: #2396F7; // 主题第二颜色--一些按钮背景色  字体颜色
  @themeColor_border: #E74552; //主题边框色  一些按钮的边框色

  @methodBox_bor: #E6E6E6; //玩法区边框色
  @oneMenuBg: #F3E2E3; //一级菜单背景色
  @oneMenuColor: #555555; // 一级菜单字体颜色
  @twoMenuColor_Lab: #333333; // 二级菜单label字体色
  @twoMenuColor_Sel: #666666; // 二级菜单选项字体色

  @gameplayColor: #666; //玩法示意字体颜色
  @gameBounsColor_Icon: #ACACAC; //玩法奖金颜色

  @chooseNumberBoxBg: #E6E6E6; //选号区背景色
  @chooseNumberBox_bor: #DCDCDC; //选号区选号边框
  @chooseNumberBoxColor_Lab: #333; //选号区label字体颜色
  @chooseNumberBoxColor_Sel: #444; //选号区选项字体颜色  全大小单双清

  @chooseNoteColor: #666666; //选注栏字体主颜色
  @chooseNoteColor_Mul: #666666; //选注栏选倍区字体颜色

  @orderColor: #333; //订单字体颜色  主
  @orderColor_Sec: #666; //订单字体颜色  副
  @orderTabBg: #F0F0F0; //订单导航条背景颜色

  @historyColor_Top: #808080;//历史开奖号码头部字体颜色

  @modalBg_btnCancel:#e8e8e8; // 模态框的取消按钮背景样式

  @userCent_bac: #f6f6f6; // 个人中心label栏的背景颜色
  @userCent_bor: #e3e3e3; // 个人中心label栏的边框颜色



















  @keyframes newMessageAni {
    0%{bottom: -80px}
    100%{bottom: 10px}
  }
  .chatMessage {
    .entrance {
      z-index: 200;
      position: fixed;
      bottom: 10px;
      right: 40px;
      width: 200px;
      height: 80px;
      cursor: pointer;
      span {
        position: absolute;
        display: flex;
        justify-content: center;
        align-items: center;
        padding: 0px 10px;
        background: @themeColor;
        border-radius: 20px;
        color: #fff;
        right: 10px;
        top: -4px;
      }
      img {
        width: 100%;
        height: 100%;
      }
    }
    .detail {
      z-index: 200;
      width: 248px;
      height: 372px;
      position: fixed;
      bottom: 10px;
      right: 80px;
      border: 1px solid #ccc;
      border-radius: 6px;
      background: #fff;
      box-shadow: 0px 0px 17px #666;
      .top {
        display: flex;
        justify-content: space-between;
        align-items: center;
        height: 48px;
        background: #eff1f4;
        border-bottom: 1px solid #eceef1;

        > div {
          display: flex;
          justify-content: center;
          align-items: center;
          height: 100%;
          color: #333;

        }
        .left, .right {
          width: 20%;
          em {
            font-size: 20px;
          }
        }
        .left {
          position: relative;
          span {
            position: absolute;
            display: flex;
            justify-content: center;
            align-items: center;
            padding: 0px 8px;
            background: @themeColor;
            border-radius: 20px;
            color: #fff;
            right: 0px;
            top: 6px;
          }
        }
        .right {
          em {
            font-size: 16px;
            cursor: pointer;
          }
        }
        .center {
          width: 60%;
          background: #fff;
          height: 66%;
          border-radius: 6px;
          justify-content: space-around;
          overflow: hidden;
          em {
            display: flex;
            width: 14%;
            justify-content: center;
            color: #333;
          }
          input {
            display: flex;
            width: 86%;
            height: 100%;
            outline: none;
            font-size: 14px;
          }
        }
      }
      .content {
        height: calc(~"100% - 48px");
        overflow: auto;
        .al_scorll();
        .box {
          .label {
            height: 54px;
            display: flex;
            justify-content: space-between;
            align-items: center;
            padding: 0 12px;
            border-bottom: 1px solid #eceef1;
            cursor: pointer;
            .left {
              display: flex;
              justify-content: left;
              align-items: center;
              em {
                display: flex;
                transform: rotate(90deg) scale(0.6);
                font-size: 12px;
                color: #666;
                transition: transform 0.2s;
                &.expand{
                  transform: rotate(180deg) scale(0.6);

                }
              }
              h4 {
                font-size: 14px;
                color: #333;
              }
            }
            .right {
              color: #666;
              font-size: 14px;
            }
          }
          .list {
            -webkit-user-select: none;
            -moz-user-select: none;
            -ms-user-select: none;
            user-select: none;
            .item {
              height: 54px;
              padding: 8px 12px;
              display: flex;
              justify-content: space-between;
              align-items: center;
              cursor: pointer;
              &:hover {
                background: #eff1f4;
              }
              > div {
                height: 100%;
              }
              .left {
                display: flex;
                justify-content: left;
                align-items: center;
                img {
                  width: 38px;
                  height: 38px;
                  margin-right: 10px;
                }
                div {
                  display: flex;
                  flex-direction: column;
                  justify-content: space-between;
                  align-items: start;
                  > span {
                    overflow: hidden;
                    text-overflow: ellipsis;
                    word-break: keep-all;
                    width: 130px;
                    text-align: left;
                  }
                  .name {
                    font-size: 14px;
                    color: #000;
                  }
                  .lastText {
                    font-size: 12px;
                    color: #666;
                    height: 20px;
                  }
                }
              }
              .right {
                display: flex;
                flex-direction: column;
                justify-content: space-between;
                align-items: center;
                .unread {
                  background: @themeColor;
                  color: #fff;
                  border-radius: 15px;
                  padding: 0 6px;
                }
              }
            }
          }
        }
      }
    }
    .newMessagePrompt{
      font-size: 16px;
      .item{
        display: flex;
        justify-content: center;
        align-items: center;
        width: 200px;
        height: 70px;
        position: fixed;
        bottom: -80px;
        left: calc(~"50% - 100px");
        background: #fff;
        box-shadow: 0 0 6px #666;
        z-index: 310;
        cursor: pointer;
        &.show{
          animation: newMessageAni 0.3s linear;
          bottom: 10px;
        }
        &.hide{
          bottom: -80px;
          transition: all 0.5s;
        }
        img{
          margin-right: 10px;
        }
      }


    }
    .dialogBox{
      position: fixed;
      width: 750px;
      height: 510px;
      left: calc(~"50% - 290px");
      /*left: calc(~"50% - 540px");*/
      top: 120px;
      background: #fff;
      .bor(#ccc);
      border-radius: 6px;
      overflow: hidden;
      box-shadow: 0 0 10px #ccc;
      z-index: 300;
      display: flex;
      justify-content: space-between;
      &.hasChatRecord{
        width: 1000px !important;
      }
      align-items: start;
      .dialogBoxList{
        width: 170px;
        /*display: flex;*/
        /*flex-direction: column;*/
        /*justify-content: left;*/
        /*align-items: center;*/
        height: 100%;
        overflow: auto;
        border-right: 1px solid #ccc;
        .al_scorll();
        .item{
          display: flex;
          justify-content: left;
          align-items: center;
          height: 55px;
          width: 100%;
          cursor: pointer;
          .left{
            img{
              width: 38px;
              height: 38px;
              margin: 0 10px;
            }
          }
          .right{
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: flex-start;
            width: 86px;
            >div{
              overflow: hidden;
              text-overflow: ellipsis;
              word-break: keep-all;
              width: 100%;
              text-align: left;
            }
            .name{
              color: #333;
              font-weight: 600;
              font-size: 14px;
            }
            .lastMessage{
              color: #666;
              font-size: 12px;
              height: 20px;
            }
          }
          .itemClose{
            display: none;
            padding-right: 5px;
            cursor: pointer;
            em{
              color: #666;
              font-size: 16px;
            }

          }
          &.active{
            background: #eff1f4;
          }
          &:hover{
            background: #eff1f4;
            .itemClose{
              display: inline-block;
            }
          }
        }
      }
      .dialogBoxContent{
        height: 100%;
        box-shadow: 0 0 10px #666;

        .top{
          width: 580px;
          display: flex;
          justify-content: space-between;
          align-items: start;
          padding: 13px 22px;
          background: #eff1f4;
          height: 70px;
          border-bottom: 1px solid #eceef1;
          cursor: all-scroll;
          .left{
            display: flex;
            justify-content: left;
            align-items: center;
            img{
              width: 44px;
              height: 44px;
            }
            div{
              display: flex;
              flex-direction: column;
              justify-content: space-between;
              align-items: start;
              margin-left: 10px;
              .name{
                font-size: 18px;
                color: #333;
              }
              .offline{
                color: #666;
                font-size: 14px;
              }
              .online{
                color: @themeColor_Sec;
              }
            }
          }
          .right{
            display: flex;
            justify-content: right;
            align-items: start;
            height: 100%;
            em{
              margin-left: 10px;
              color: #666;
              cursor: pointer;
            }
          }
        }
        .messageList{
          width: 100%;
          height: 288px;
          overflow: auto;
          padding: 15px 22px;
          .al_scorll();
          .item{
            margin-bottom: 10px;
            .date{
              width: 100%;
              color: #888;
              font-size: 12px;
            }
            .photo{
              img{
                width: 48px;
                height: 48px;
              }
            }
            .content{
              margin: 0 15px;
              position: relative;
              padding-top: 10px;
              .tri{
                position: absolute;
                width:0;
                height:0;
                overflow:hidden;
                font-size: 0;     /*是因为, 虽然宽高度为0, 但在IE6下会具有默认的 */
                line-height: 0;  /* 字体大小和行高, 导致盒子呈现被撑开的长矩形 */
                border-width: 6px;
                border-style:solid;  /*ie6下会出现不透明的兼容问题*/
              }
              .text{
                font-size: 14px;
                padding: 5px;
                border-radius: 4px;
                max-width: 280px;
                word-break: break-word;
                text-align: left;
              }
            }
            .messageSend{
              display: flex;
              justify-content: right;
              flex-direction: row-reverse;
              .content{
                color: #fff;
                .tri{
                  border-color:transparent  transparent  transparent @themeColor_Sec;
                  top: 18px;
                  right: -12px;
                }
                .text{
                  background: @themeColor_Sec;
                }
              }
            }
            .messageReceive{
              display: flex;
              justify-content: left;
              .content{
                color: #333;
                .tri{
                  border-color:transparent #e7e7e7 transparent  transparent;
                  top: 18px;
                  left: -12px;
                }
                .text{
                  background: #e7e7e7;

                }
              }
            }
          }
        }
        .bottom{
          width: 100%;
          height: calc(~"100% - 70px - 288px");
          // border-top: 1px solid #ccc;
          padding: 10px 22px;
          position: relative;
          .tool{
            display: flex;
            justify-content: space-between;
            align-items: center;
            font-size: 14px;
            border-bottom: 1px solid #ccc;
            color: #333;
            .right{
              cursor: pointer;
              em{
                font-size: 14px;
                color: #666;
                margin-right: 5px;
              }
            }
          }
          textarea{
            height: calc(~"100% - 5px - 34px - 21px");
            width: 100%;
            outline: none;
            resize: none;
            font-size: 14px;
            padding: 4px;
            color: #333;
            border: none;

          }
          textarea::-webkit-input-placeholder{
            color: #666 !important;
          }
          textarea::-ms-input-placeholder{
            color: #666 !important;
          }
          textarea::-moz-placeholder{
            color: #666 !important;
          }
          textarea:-ms-input-placeholder{
            color: #666 !important;
          }
          .reLink{
            width: calc(~"100% - 44px");
            position: absolute;
            height: calc(~"100% - 5px - 34px - 43px");
            background: rgba(100,100,100,0.6);
            top: 32px;
            left: 22px;
            color: #fff;
            display: flex;
            justify-content: center;
            align-items: center;
            font-size: 16px;
          }
          .btn{
            display: flex;
            justify-content: flex-end;
            align-items: center;
            width: 100%;
            height: 34px;
            border: 0;
            >span{
              display: flex;
              justify-content: center;
              align-items: center;
              color: #fff;
              width: 64px;
              height: 34px;
              border-radius: 4px;
              font-size: 16px;
              cursor: pointer;
            }
            .end{
              background: #bbb;
              margin-right: 6px;
            }
            .send{
              background: @themeColor;
            }
          }
        }
      }
      .chatRecord{
        width: 250px;
        height: 100%;

        .top{
          width: 100%;
          height: 70px;
          background: rgba(120, 121, 122, 0.1);
          color: #666;
          font-size: 16px;
          display: flex;
          justify-content: center;
          align-items: center;
          position: relative;
          em{
            position: absolute;
            right: 10px;
            top: 10px;
            font-size: 12px;
            color: #666;
            cursor: pointer;
          }
         }
        .chatRecordContent{
          height: calc(~"100% - 70px");
          overflow: auto;
          .al_scorll();
          padding: 10px;
          .item{
            margin-bottom: 10px;
            .date{
              width: 100%;
              color: #888;
              font-size: 12px;
            }
            .photo{
              img{
                width: 48px;
                height: 48px;
              }
            }
            .content{
              margin: 0 15px;
              position: relative;
              padding-top: 10px;
              .tri{
                position: absolute;
                width:0;
                height:0;
                overflow:hidden;
                font-size: 0;     /*是因为, 虽然宽高度为0, 但在IE6下会具有默认的 */
                line-height: 0;  /* 字体大小和行高, 导致盒子呈现被撑开的长矩形 */
                border-width: 6px;
                border-style:solid;  /*ie6下会出现不透明的兼容问题*/
              }
              .text{
                font-size: 14px;
                padding: 5px;
                border-radius: 4px;
                max-width: 280px;
                word-break: break-word;
                text-align: left;
              }
            }
            .messageSend{
              display: flex;
              justify-content: left;
              flex-direction: row-reverse;
              .content{
                color: #fff;
                .tri{
                  border-color:transparent  transparent  transparent @themeColor_Sec;
                  top: 18px;
                  right: -12px;
                }
                .text{
                  background: @themeColor_Sec;
                }
              }
            }
            .messageReceive{
              display: flex;
              justify-content: right;
              .content{
                color: #333;
                .tri{
                  border-color:transparent #e7e7e7 transparent  transparent;
                  top: 18px;
                  left: -12px;
                }
                .text{
                  background: #e7e7e7;

                }
              }
            }
          }
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// chatMessage.vue?e36b4f10